module.exports = {
      id: "plan-selected-usage",
      viewBox: "0 0 28 28",
      url: __webpack_public_path__ + "images/js_src_vue/page_islide_landing/sprite.30abe696.svg#plan-selected-usage",
      toString: function () {
        return this.url;
      }
    }